import { type NotificationItem } from '@/lib/queries/notification/v1/history/types'

import { UpdateItem } from '../update-item/update-item'

export interface CaseUpdateListProps {
  notifications: NotificationItem[]
}

export const CaseUpdateList = ({ notifications }: CaseUpdateListProps) => {
  return (
    <ul>
      {notifications.map((item, index) => (
        <li key={`${item.messageType}-${item.message}-${item.createdAt}-${index}`}>
          <UpdateItem data={item} />
        </li>
      ))}
    </ul>
  )
}
